export const DEFAULT_PAGE = 1
export const DEFAULT_LIMIT = 50

const ARRAY_SEPARATOR = '|'

export const parseStringArray = (param: string | null): string[] =>
    param?.split(ARRAY_SEPARATOR).filter(Boolean) || []

export const serializeStringArray = (arr: string[]): string =>
    arr.join(ARRAY_SEPARATOR)

export const parsePageFromUrl = (searchParams: URLSearchParams): number => {
    const pageParam = searchParams.get('page')
    return pageParam &&
        !isNaN(parseInt(pageParam, 10)) &&
        parseInt(pageParam, 10) > 0
        ? parseInt(pageParam, 10)
        : DEFAULT_PAGE
}

export const parseLimitFromUrl = (searchParams: URLSearchParams): number => {
    const limitParam = searchParams.get('limit')
    return limitParam &&
        !isNaN(parseInt(limitParam, 10)) &&
        parseInt(limitParam, 10) > 0
        ? parseInt(limitParam, 10)
        : DEFAULT_LIMIT
}
